import React, { PureComponent } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FilePond, registerPlugin } from 'react-filepond';
import { create } from '../../../../react-doka/lib/doka.esm.min';

import '../../../../react-doka/lib/doka.min.css';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.min.css';

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import { populateListingFromFormData } from '../helpers';
import { updateListingPhotos, updateListing, setListing, updateFormData } from '../actions';
import { ListingPhotosSchema } from '../validation';
import { fileBaseUrl } from '../../../../config';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImagePreview,
  FilePondPluginImageEdit,
  FilePondPluginImageTransform,
  FilePondPluginFileValidateType
)

const mapStateToProps = state => ({
  listing: state.Listing
});

class ListingFormPhotos extends PureComponent {
  constructor(props) {
    super(props);

    let photos = this.props.listing.photos;
    if (this.props.workflow === "edit") {
      photos = props.listing.photos.map(file => ({ source: file.name, options: { type: 'local' } }));
    }
    else if (!this.props.listing.photos.length && props.listing.formData.photos) {
      photos = props.listing.formData.photos.map(file => ({ source: file, options: { type: 'local' } }));
    }

    this.state = {
      files: photos
    };

    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/photosOrder`;
    this.prevPage = `/${this.props.parent}/listing/${workflow}/amenities`;
  }

  saveListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true });
    const createBlobs = true;
    let { dispatch, listing, step, history } = this.props;
    if (values.lastCompleted < step) { values.lastCompleted = step; }
    dispatch(updateFormData(values));
    let updatedData = populateListingFromFormData(values);
    if (!updatedData._id) { updatedData._id = listing.listingData._id; }
    dispatch(setListing(updatedData));
    dispatch(updateListing(createBlobs)).then(() => {
      history.push(pathAfterSave);
    })
  }

  onSubmit = (values, { setSubmitting }) => {
    this.pond.processFiles().then((something) => {
      setSubmitting(false);
      this.saveListing(values, this.nextPage);
    });
  }

  submitAndExit = (values) => {
    this.pond.processFiles().then(() => {
      this.saveListing(values, `/${this.props.parent}/manage-listings`);
    })
  }

  submitAndBack = (values) => {
    this.pond.processFiles().then(() => {
      this.saveListing(values, this.prevPage);
    })
  }

  handleConfirm = (output, item) => {
    this.pond.processFile(item);
  }

  handleUpdate = (fileItems) => {
    var fileList = fileItems.map(fileItem => fileItem.file);
    this.setState({
      files: fileList
    });
    this.props.dispatch(updateListingPhotos(fileList));
  }

  handleProcess = (name, file, metadata, load) => {
    var files = this.state.files.slice();
    var updatedFileName = file.name.toLowerCase().split('.')[0]
    var index = files.findIndex(f => f.name.toLowerCase().split('.')[0] === updatedFileName);
    files.splice(index, 1, file);
    this.setState({
      files: files
    });

    return load ? load(Date.now()) : Promise.resolve(true);
  }

  render() {
    let values = this.props.listing.formData;
    let imageServerUrl = `${fileBaseUrl}/${values.id}/`;
    const submitButtonText = this.props.exit ? 'Save' : 'Next';
    return (
      <Formik onSubmit={this.onSubmit} initialValues={values} validationSchema={ListingPhotosSchema}>
        {({ values, errors, setFieldValue, submitForm }) => (
          <Form>
            <div>
              <h5>Manage Photos</h5>
              <div>
                Choose a variety of photos of your home. Well-lit views of each room
                and the exterior will help renters get an accurate feel for your space.
              </div>
              <div className="highlight">
                You can change the display order of your uploaded images after clicking "Save & Next".
              </div>
              <div className="py-3">
                <strong>Note:</strong> Limit 25 photos, up to 5MB total. Documents can be uploaded
                as .png, .jpg, or .tiff.
              </div>
              <div className="pb-3"><strong>1) Upload Files</strong></div>
              <Field name="photos" className="pt-2">
                {() => (
                  <FilePond
                    ref={ref => (this.pond = ref)}
                    files={this.state.files}
                    instantUpload={false}
                    acceptedFileTypes={['image/png', 'image/jpeg', 'image/tiff']}
                    server={{
                      load: imageServerUrl,
                      process: this.handleProcess
                    }}
                    iconProcess={''}
                    labelFileProcessing="Editing image..."
                    allowMultiple={true}
                    styleItemPanelAspectRatio={.5625}
                    imageEditEditor={create({
                      onconfirm: this.handleConfirm
                    })}
                    onupdatefiles={this.handleUpdate}
                  /> //end filepond
                )}
              </Field>
              <ErrorMessage name="photos" component="div" className="error-message" />
            </div>
            <div className="button-row row">
              <div className="col-4">
                <label className="float-left" onClick={
                  () => { this.submitAndBack(values) }
                }
                >Back</label>
              </div>
              <div className="col-8">
                <div className="row">
                  <div className="col-md-6 col-12">
                    {
                      this.props.workflow !== "edit" &&
                      <label className="float-right" onClick={() => { this.submitAndExit(values) }}>Save &amp; Finish Later</label>
                    }
                  </div>
                  <div className="col-md-6 col-12">
                    {
                      this.state.isSubmitting
                        ? <button className="btn-primary float-right" disabled={true} onClick={() => { }}>
                          Saving...
                        </button>
                        : <button className="btn-primary float-right" type="submit">
                          {submitButtonText}
                        </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormPhotos));
